<template>
  <a-card title="Danh sách công việc" class="root-card">
    <div id="actions">
      <div class="left-actions">
        <a-button type="primary" @click="handleFetchJobs"><a-icon type="reload" /> Làm mới</a-button>
        <a-button type="primary" style="background-color: #ddb72a; border-color: #ddb72a" @click="handleForceFetchJobs"><a-icon type="reload" /> Làm mới (force)</a-button>
        <a-button type="danger" :disabled="tables.jobsTable.selectedIds.length <= 0" @click="handleDeleteJobs"><a-icon type="delete" /> Xóa</a-button>
      </div>
      <div class="right-actions">
        <a-switch :checked="autoReloadCheck" checked-children="Tự động làm mới" un-checked-children="Tự động làm mới" default-checked @change="onChangeAutoReloadSwitch" />
      </div>
    </div>
    <br />
    <a-table
      id="job-list-table"
      :columns="tables.jobsTable.columns"
      :data-source="jobs"
      :loading="loading.jobsTable"
      :row-selection="tables.jobsTable.rowSelection"
      :row-class-name="rowClassName"
      :pagination="tables.jobsTable.pagination"
      :scroll="{ x: 2700, y: 450 }"
    bordered>
      <div style="white-space: pre-wrap;" slot="description" slot-scope="description">{{description}}</div>
      <a-tag slot="status" slot-scope="status" :color="JobStatusProperties[status].color">{{JobStatusProperties[status].title}}</a-tag>
      <b slot="scenario" slot-scope="scenario">{{scenario}}</b>
      <a-badge slot="input_count" slot-scope="input_count, record" :overflowCount="9999999" :show-zero="record.has_input" :count="input_count" :number-style="{ backgroundColor: '#999' }" />
      <template slot="threads" slot-scope="threads, record">
        <a-badge :overflowCount="9999999" show-zero :count="threads" :number-style="{ backgroundColor: '#999' }" />
        <a href="javascript:;" @click="$router.push({ name: 'ListThread', params: { id: String(record.metadata.id) }})" style="color: #880798; margin-left:15px" ><a-icon type="eye" /></a>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          style="color: #3d7a1e"
          v-if="record.status == JobStatus.PENDING"
          title="Bạn có chắc muốn thực thi công việc này?"
          @confirm="() => handleStartJob(record.metadata.id)"
        >
          <a href="javascript:;"><a-icon type="play-circle" /> Chạy</a>
        </a-popconfirm>
        <a-popconfirm
          style="color: #7f6307; margin-left:15px"
          v-if="record.status == JobStatus.RUNNING"
          title="Bạn có chắc muốn dừng công việc này?"
          @confirm="() => handleStopJob(record.metadata.id)"
        >
          <a href="javascript:;"><a-icon type="pause-circle" /> Dừng</a>
        </a-popconfirm>
        <a-popconfirm
          style="margin-left: 15px; color: red"
          title="Bạn có chắc muốn restart công việc này?"
          @confirm="() => handleRestartJob(record.metadata.id)"
        >
          <a href="javascript:;"><a-icon type="redo" /> Restart</a>
        </a-popconfirm>
        <a href="javascript:;" style="color: rgb(52 195 111); margin-left:15px" @click="viewLogs(record.metadata.id)"><a-icon type="eye" /> Logs</a>
        <a href="javascript:;" style="color: rgb(76 51 205); margin-left:15px" @click="seeConfig(record.metadata.id)"><a-icon type="edit" /> Cấu hình</a>
        <a-popconfirm
          style="margin-left: 15px; color: magenta"
          v-if="record.status == JobStatus.PENDING"
          title="Bạn có chắc muốn đặt lại toàn bộ dữ liệu (thống kê, input, ...) của công việc này?"
          @confirm="() => handleClearJob(record.metadata.id)"
        >
          <a href="javascript:;"><a-icon type="reload" /> Đặt lại</a>
        </a-popconfirm>
        <a-popconfirm
          style="margin-left: 15px"
          title="Bạn có chắc muốn xóa công việc này?"
          @confirm="() => handleDeleteJobs([record.metadata.id])"
        >
          <a href="javascript:;" style="color: red"><a-icon type="delete" /> Xóa</a>
        </a-popconfirm>
      </template>
      <a-badge :overflowCount="9999999" slot="pending" slot-scope="pending" show-zero :count="pending" :number-style="{ backgroundColor: '#999' }" />
      <a-badge :overflowCount="9999999" slot="processing" slot-scope="processing" show-zero :count="processing" :number-style="{ backgroundColor: 'orange' }" />
      <a-badge :overflowCount="9999999" slot="success" slot-scope="success" show-zero :count="success" :number-style="{ backgroundColor: '#52c41a' }" />
      <template slot="error" slot-scope="error, record">
        <a-badge :overflowCount="9999999" show-zero :count="error" :number-style="{ backgroundColor: 'red' }" />
        <a href="javascript:;" @click="seeErrors(record.metadata.id)" style="color: #880798; margin-left:15px" ><a-icon type="eye" /></a>
      </template>
      <span slot="success_rate" slot-scope="success_rate"><b>{{parseInt(success_rate)}}%</b></span>
      <span slot="recent_success_rate" slot-scope="recent_success_rate"><b>{{parseInt(recent_success_rate)}}%</b></span>
      <span slot="speed_per_minute" slot-scope="speed_per_minute"><b>{{parseInt(speed_per_minute)}}</b> / Phút</span>
      <span v-if="!!start_time" slot="start_time" slot-scope="start_time">{{new Date(start_time).toLocaleString()}}</span>
      <span v-if="!!end_time" slot="end_time" slot-scope="end_time">{{new Date(end_time).toLocaleString()}}</span>
      <span v-if="!!record.start_time" slot="total_time" slot-scope="text, record">{{formatTimeDistance(record.start_time, record.end_time || Date.now())}}</span>

      <span slot="build_id" slot-scope="text, record"><b>{{record?.build?.id}}</b></span>
      <span slot="build_time" slot-scope="text, record">{{record?.build?.time ? new Date(record?.build?.time).toLocaleString() : ''}}</span>
    </a-table>
    <a-modal id="errors" width="800px" v-model="visible.listErrorsModal" :title="`Danh sách lỗi của công việc: ${jobToSeeErrorsList?.metadata?.title}`" @ok="() => visible.listErrorsModal = false">
      <div v-if="!jobToSeeErrorsList || jobToSeeErrorsList.errors.length == 0">Không có lỗi nào!</div>
      <a-list bordered v-if="jobToSeeErrorsList && jobToSeeErrorsList.errors.length > 0" :data-source="jobToSeeErrorsList.errors">
        <a-list-item slot="renderItem" slot-scope="error">
          <a-list-item-meta>
            <span slot="title">{{ error.message }}</span>
            <a-badge :overflowCount="9999999" slot="avatar" show-zero :count="error.count" :number-style="{ backgroundColor: '#999' }" />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-modal>
    <a-modal id="config" width="800px" v-model="visible.viewJobConfig" :title="`Cấu hình công việc: ${jobToSeeConfig?.metadata?.title}`" @ok="handleUpdateJob()" okText="Cập nhật">
      <div v-if="!jobToSeeConfig || jobToSeeConfig.metadata.params.length == 0">Không có cấu hình!</div>
      <a-form-model layout="vertical">
        <a-form-model-item v-if="jobToSeeConfig && jobToSeeConfig.metadata.params.length > 0">
          <a-form-model-item v-for="param in jobToSeeConfig.metadata.params" :key="param.key" :label="`${param.title}`">
            <template v-if="param.tag_index">
              <a-select :disabled="jobToSeeConfig.status == JobStatus.RUNNING" v-model="formData.updateParams[param.key]" :placeholder="param.description || param.title" allowClear>
                <a-select-option v-for="tag in tagsByIndex(param.tag_index)" :key="String(tag.id)" :value="String(tag.id)">
                  <a-tag>{{ tag.title }}</a-tag>
                </a-select-option>
              </a-select>
            </template>
            <template v-else-if="param.options">
              <a-select :disabled="jobToSeeConfig.status == JobStatus.RUNNING" v-model="formData.updateParams[param.key]" :placeholder="param.description || param.title">
                <a-select-option v-for="option in param.options" :key="String(option.value)" :value="String(option.value)">
                  {{ option.title }}
                </a-select-option>
              </a-select>
            </template>
            <template v-else-if="param.type === 'string'">
              <a-input :disabled="jobToSeeConfig.status == JobStatus.RUNNING" v-model="formData.updateParams[param.key]" :placeholder="param.description || param.title" />
            </template>
            <template v-else-if="param.type === 'number'">
              <a-input-number :disabled="jobToSeeConfig.status == JobStatus.RUNNING" v-model="formData.updateParams[param.key]" :placeholder="param.description || param.title" style="width: 100%" />
            </template>
            <template v-else-if="param.type === 'boolean'">
              <a-select :disabled="jobToSeeConfig.status == JobStatus.RUNNING" v-model="formData.updateParams[param.key]" :placeholder="param.description || param.title">
                <a-select-option value="true">True</a-select-option>
                <a-select-option value="false">False</a-select-option>
              </a-select>
            </template>
          </a-form-model-item>
        </a-form-model-item>
      </a-form-model>
      <a-alert
        description="Lưu ý: việc cập nhật cấu hình sẽ xóa toàn bộ dữ liệu của công việc!"
        type="warning"
        show-icon
      />
    </a-modal>
    <a-modal id="logs" :dialog-style="{ top: '20px' }" width="1400px" v-model="visible.viewLogs" :title="`Logs của công việc: ${jobToViewLogs?.metadata?.title}`" @ok="() => visible.viewLogs = false">
      <div id="actions">
        <a-button type="primary" @click="fetchLogs()"><a-icon type="reload" /> Làm mới</a-button>
        <a-input-number v-model="logLines" addon-before="Lines" style="width: 100px" />
      </div>
      <br>
      <LogViewer :logs="logs" :height="`600px`" />
    </a-modal>
  </a-card>
</template>

<style scoped>
#actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-actions {
  display: flex;
  gap: 15px;
}

.right-actions {
  display: flex;
  gap: 15px;
}

.ant-form-item {
  margin-bottom: 10px !important;
}
</style>

<style>
.warning-row {
  background-color: #fffbe6;
}
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import LogViewer from './LogViewer.vue';

const jobsListTableColumns = [
  {
    title: 'Tiêu đề',
    dataIndex: 'metadata.title',
    key: 'title',
  },
  {
    title: 'Mô tả',
    dataIndex: 'metadata.description',
    key: 'description',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: 'Kịch bản',
    dataIndex: 'metadata.scenario.title',
    key: 'scenario',
    scopedSlots: { customRender: 'scenario' }
  },
  {
    title: 'Inputs',
    dataIndex: 'input_count',
    key: 'input_count',
    align: 'center',
    width: '80px',
    scopedSlots: { customRender: 'input_count' },
  },
  {
    title: 'Threads',
    dataIndex: 'thread_count',
    key: 'threads',
    align: 'center',
    width: '100px',
    scopedSlots: { customRender: 'threads' },
  },
  {
    title: 'Thống kê',
    children: [
      {
        title: 'Đang Chờ',
        dataIndex: 'pending',
        key: 'pending',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'pending' },
      },
      {
        title: 'Đang Chạy',
        dataIndex: 'processing',
        key: 'processing',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'processing' },
      },
      {
        title: 'Hoàn thành',
        dataIndex: 'success',
        key: 'success',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'success' },
      },
      {
        title: 'Lỗi',
        dataIndex: 'error',
        key: 'error',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'error' },
      },
      {
        title: 'Tỉ lệ thành công (recently)',
        dataIndex: 'recent_success_rate',
        key: 'recent_success_rate',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'recent_success_rate' },
      },
      {
        title: 'Tỉ lệ thành công',
        dataIndex: 'success_rate',
        key: 'success_rate',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'success_rate' },
      },
      {
        title: 'Tốc độ',
        dataIndex: 'speed_per_minute',
        key: 'speed_per_minute',
        align: 'center',
        width: '100px',
        scopedSlots: { customRender: 'speed_per_minute' },
      },
    ]
  },
  {
    title: 'Thời gian',
    children: [
      {
        title: 'Bắt đầu',
        dataIndex: 'start_time',
        key: 'start_time',
        align: 'center',
        scopedSlots: { customRender: 'start_time' },
        width: '170px'
      },
      {
        title: 'Kết thúc',
        dataIndex: 'end_time',
        key: 'end_time',
        align: 'center',
        scopedSlots: { customRender: 'end_time' },
        width: '170px'
      },
      {
        title: 'Tổng',
        align: 'center',
        scopedSlots: { customRender: 'total_time' },
        width: '100px'
      }
    ]
  },
   {
    title: 'Build',
    children: [
      {
        title: 'ID',
        dataIndex: 'build_id',
        key: 'build_id',
        align: 'center',
        scopedSlots: { customRender: 'build_id' },
        width: '130px'
      },
      {
        title: 'Thời gian',
        dataIndex: 'build_time',
        key: 'build_time',
        align: 'center',
        scopedSlots: { customRender: 'build_time' },
        width: '170px'
      },
    ]
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    fixed: 'right',
    scopedSlots: { customRender: 'status' },
    width: '110px'
  },
  {
    title: 'Thao tác',
    fixed: 'right',
    width: '450px',
    scopedSlots: { customRender: 'operation' },
  }
]

const JobStatus = {
  PENDING: 0,
  RUNNING: 1,
};

const JobStatusProperties = {
  [JobStatus.PENDING]: {
    title: 'Đang Chờ'
  },
  [JobStatus.RUNNING]: {
    title: 'Đang Chạy',
    color: 'orange'
  },
}

export default {
  components: {LogViewer},
  data() {
    return {
      app: this.$root.$children[0],
      tables: {
        jobsTable: {
          columns: jobsListTableColumns,
          selectedIds: [],
          rowSelection: {
            onChange: (selectedRowKeys, selectedRows) => {
              this.tables.jobsTable.selectedIds = selectedRows.map(row => row.metadata.id);
            }
          },
          pagination: {
            showSizeChanger: true,
            pageSizeOptions: ['10', '30', '50', '100', '200', '500', '1000'],
            showQuickJumper: true,
            showTotal: (total, range) => {
              return `${range[0]} - ${range[1]} of ${total}`;
            }
          },
        }
      },
      loading: {
        jobsTable: false,
      },
      JobStatus: JobStatus,
      JobStatusProperties: JobStatusProperties,
      visible: {
        viewJobWorkersModal: false,
        listErrorsModal: false,
        viewJobConfig: false,
        viewLogs: false
      },
      selected: {
        jobWorkerToView: [],
        jobIdToDeleteWorkers: undefined
      },
      autoReloadCheck: false,
      autoReloadInterval: undefined,
      choose: {
        seeErrorList: undefined,
        seeConfig: undefined,
        viewLogs: undefined
      },
      formData: {
        updateParams: {}
      },
      logLines: 100,
      logs: ''
    }
  },
  computed: {
    ...mapGetters('job', {
      jobs: "getJobs"
    }),

    ...mapGetters('tag', {
      tags: 'getTags'
    }),

    ...mapGetters('serviceActuator', {
      buildInfo: "getBuildInfo"
    }),

    jobToSeeErrorsList() {
      if (this.choose.seeErrorList == undefined) {
        return undefined;
      }

      return this.jobs.find(j => j.metadata.id == this.choose.seeErrorList);
    },

    jobToSeeConfig() {
      if (this.choose.seeConfig == undefined) {
        return undefined;
      }

      return this.jobs.find(j => j.metadata.id == this.choose.seeConfig);
    },

    jobToViewLogs() {
      if (this.choose.viewLogs == undefined) {
        return undefined;
      }

      return this.jobs.find(j => j.metadata.id == this.choose.viewLogs);
    },
  },
  mounted() {
    this.handleFetchJobs();
    this.fetchTags({
      index: 'x-account'
    });
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.autoReloadInterval);
    next();
  },
  methods: {
    ...mapActions('job', {
      fetchJobs: "fetchJobs",
      deleteJobs: "deleteJobs",
      startJob: "startJob",
      stopJob: "stopJob",
      restartJob: "restartJob",
      clearJob: "clearJob",
      updateJob: "updateJob",
      getLogs: "getLogs"
    }),

    ...mapActions("tag", {
      fetchTags: "fetchTags"
    }),

    ...mapActions('scenario', {
      setScenarioConfig: "setScenarioConfig",
    }),

    tagsByIndex(index) {
      return this.tags.filter(t => t.index == index);
    },

    rowClassName(record) {
      return record?.build?.id !== this.buildInfo.id ? 'warning-row' : '';
    },

    viewLogs(id) {
      this.choose.viewLogs = id;
      this.visible.viewLogs = true;
      this.fetchLogs();
    },

    fetchLogs() {
      this.app.callApi(async () => {
        this.logs = await this.getLogs({
          id: this.choose.viewLogs,
          lines: this.logLines
        });
      });
    },

    seeErrors(id) {
      this.choose.seeErrorList = id;
      this.visible.listErrorsModal = true;
    },

    seeConfig(id) {
      this.choose.seeConfig = id;
      this.visible.viewJobConfig = true;

      this.formData.updateParams = this.jobToSeeConfig.metadata.params.reduce((acc, param) => {
        acc[param.key] = (param && param.value != null && param.value != undefined) ? String(param.value) : (param.default ? String(param.default) : undefined);
        return acc;
      }, {});
    },

    handleUpdateJob() {
      const savedParams = {
        scenario_id: this.jobToSeeConfig.metadata.scenario.id,
        raw_metadata: JSON.stringify(this.formData.updateParams)
      }

      this.app.callApi(async () => {
        await Promise.all([
          this.setScenarioConfig(savedParams),
          this.updateJob({
            id: this.jobToSeeConfig.metadata.id,
            params: this.formData.updateParams
          })
        ]);
        this.$message.success('Cập nhật cấu hình công việc thành công!');
        this.handleFetchJobs();
        this.visible.viewJobConfig = false;
      });
    },

    handleStartJob(jobId) {
      this.app.callApi(async () => {
        await this.startJob(jobId);
        this.$message.success('Khởi động công việc thành công!');
        this.handleFetchJobs();
      });
    },

    handleStopJob(jobId) {
      this.app.callApi(async () => {
        await this.stopJob(jobId);
        this.$message.warn('Công việc của bạn sẽ sớm dừng lại!');
        this.handleFetchJobs();
      });
    },

    handleRestartJob(jobId) {
      this.app.callApi(async () => {
        this.loading.jobsTable = true;
        this.$message.warn('Công việc của bạn đang được khởi tạo lại');
        await this.restartJob(jobId);
        this.handleFetchJobs();
      }, () => {
        this.loading.jobsTable = false;
      });
    },

    handleClearJob(jobId) {
      this.app.callApi(async () => {
        await this.clearJob(jobId);
        this.$message.success('Công việc của bạn đã được dọn dẹp!');
        this.handleFetchJobs();
      });
    },

    async handleFetchJobs() {
      this.loading.jobsTable = true;
      await this.fetchJobs();
      this.loading.jobsTable = false;
    },

    async handleForceFetchJobs() {
      this.loading.jobsTable = true;
      await this.fetchJobs(true);
      this.loading.jobsTable = false;
    },

    onChangeAutoReloadSwitch(checked) {
      this.autoReloadCheck = checked;

      if (checked) {
        this.autoReloadInterval = setInterval(this.handleFetchJobs.bind(this), 2000);
      } else {
        clearInterval(this.autoReloadInterval);
      }
    },

    handleDeleteJobs(ids) {
      if (!ids || !Array.isArray(ids)) {
        ids = this.tables.jobsTable.selectedIds;
      }

      const handler = async () => {
        this.app.callApi(async () => {
          this.loading.jobsTable = true;
          const {message} = await this.deleteJobs(ids);
          this.tables.jobsTable.selectedIds = [];
          await this.fetchJobs();
          this.loading.jobsTable = false;
          this.$message.success(message);
        }, () => this.loading.jobsTable = false);
      }

      if (ids.length == 1) {
        handler();
        return;
      }

      if (ids.length > 1) {
        this.$confirm({
          title: 'Bạn có chắc muốn xóa những công việc này?',
          content: 'Khi bạn click OK, dữ liệu sẽ bị xóa.',
          onOk: handler
        });
      }
    },

    formatTimeDistance(start, end) {
      if (!start || !end) {
        return undefined;
      }

      start = new Date(start);
      end = new Date(end);

      const distance = Math.abs(end - start) / 1000; // Convert to seconds

      const hours = Math.floor(distance / 3600);
      const minutes = Math.floor((distance % 3600) / 60);
      const seconds = Math.round(distance % 60);

      const formattedTime = [];

      if (hours > 0) {
        formattedTime.push(`${hours}h`);
      }

      if (minutes > 0) {
        formattedTime.push(`${minutes}m`);
      }

      if (seconds > 0) {
        formattedTime.push(`${seconds}s`);
      }

      return formattedTime.join('');
    },
  }
}
</script>
